




















import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import { ChartB2BB2CData } from '@/model/dashboard/ChartB2BB2CData'
import _ from 'lodash'
import moment from 'moment'

am4core.useTheme(am4themes_animated)

interface ComponentData {
  chart: any
  toggleButtons: number
  minYear: number
  maxYear: number
  selectedYear: number
  chartData: any | null
}

export default Vue.extend({
  name: 'LineChartB2BB2C',

  props: {
    chartB2BB2CLabel: String,
    chartB2BB2CData: {
      type: Array as () => ChartB2BB2CData[]
    },
    chartB2BB2CDate: String
  },

  data (): ComponentData {
    return {
      chart: undefined,
      toggleButtons: 0,
      minYear: parseInt(moment().format('YYYY')),
      maxYear: parseInt(moment().format('YYYY')),
      selectedYear: parseInt(moment().format('YYYY')),
      chartData: null
    }
  },

  watch: {
    toggleButtons (newVal: number): void {
      this.createChart()
    }
  },

  methods: {
    onBeforeClick (): void {
      this.selectedYear = this.selectedYear - 1
      this.createChart()
    },

    onNextClick (): void {
      this.selectedYear = this.selectedYear + 1
      this.createChart()
    },

    createChart (): any {
      //@ts-ignore
      let chart = am4core.create(this.$refs.columnChart, am4charts.XYChart)

      const data = [
          { "month": '1', "label": "01", "B2B": null, "B2C": null, "total": null },
          { "month": '2', "label": "02", "B2B": null, "B2C": null, "total": null },
          { "month": '3', "label": "03", "B2B": null, "B2C": null, "total": null },
          { "month": '4', "label": "04", "B2B": null, "B2C": null, "total": null },
          { "month": '5', "label": "05", "B2B": null, "B2C": null, "total": null },
          { "month": '6', "label": "06", "B2B": null, "B2C": null, "total": null },
          { "month": '7', "label": "07", "B2B": null, "B2C": null, "total": null },
          { "month": '8', "label": "08", "B2B": null, "B2C": null, "total": null },
          { "month": '9', "label": "09", "B2B": null, "B2C": null, "total": null },
          { "month": '10', "label": "10", "B2B": null, "B2C": null, "total": null },
          { "month": '11', "label": "11", "B2B": null, "B2C": null, "total": null },
          { "month": '12', "label": "12", "B2B": null, "B2C": null, "total": null }
      ]

      if(this.chartData[this.selectedYear]) {

        chart.data = data.map((item: any) => {
          this.chartData[this.selectedYear].forEach((i: ChartB2BB2CData) => {
            if (i.month === item.month) {
              if (i.privateAddress === '0') {
                item.B2B = i.sum
              } else if (i.privateAddress === '1') {
                item.B2C = i.sum
              }
              if(item.B2B) {
                item.total = parseFloat(item.B2B)
              }

              if(item.B2C) {
                item.total += parseFloat(item.B2C)
              }
            }
          })

          return item
        })

        if (this.toggleButtons === 1) {
          let q: any[] = []
          chart.data.forEach((item: any, index: number) => {
            if (index < 3) {
              if (q[0]) {
                q[0].B2B = item.B2B ? q[0].B2B ? parseFloat(q[0].B2B) + parseFloat(item.B2B) : parseFloat(item.B2B) : q[0].B2B
                q[0].B2C = item.B2C ? q[0].B2C ? parseFloat(q[0].B2C) + parseFloat(item.B2C) : parseFloat(item.B2C) : q[0].B2C
              } else {
                item.total = null
                item.month = ''
                item.label = 'Q1'
                q.push(item)
              }
            } else if (index < 7) {
              if (q[1]) {
                q[1].B2B = item.B2B ? q[1].B2B ? parseFloat(q[1].B2B) + parseFloat(item.B2B) : parseFloat(item.B2B) : q[1].B2B
                q[1].B2C = item.B2C ? q[1].B2C ? parseFloat(q[1].B2C) + parseFloat(item.B2C) : parseFloat(item.B2C) : q[1].B2C
              } else {
                item.total = null
                item.month = ''
                item.label = 'Q2'
                q.push(item)
              }
            } else if (index < 9) {
              if (q[2]) {
                q[2].B2B = item.B2B ? q[2].B2B ? parseFloat(q[2].B2B) + parseFloat(item.B2B) : parseFloat(item.B2B) : q[2].B2B
                q[2].B2C = item.B2C ? q[2].B2C ? parseFloat(q[2].B2C) + parseFloat(item.B2C) : parseFloat(item.B2C) : q[2].B2C
              } else {
                item.total = null
                item.month = ''
                item.label = 'Q3'
                q.push(item)
              }
            } else {
              if (q[3]) {
                q[3].B2B = item.B2B ? q[3].B2B ? parseFloat(q[3].B2B) + parseFloat(item.B2B) : parseFloat(item.B2B) : q[3].B2B
                q[3].B2C = item.B2C ? q[3].B2C ? parseFloat(q[3].B2C) + parseFloat(item.B2C) : parseFloat(item.B2C) : q[3].B2C
              } else {
                item.total = null
                item.month = ''
                item.label = 'Q4'
                q.push(item)
              }
            }
          })

          q.forEach((item: any) => {
            if(item.B2B) {
              item.total = parseFloat(item.B2B)
            }

            if(item.B2C) {
              item.total += parseFloat(item.B2C)
            }
          })

          chart.data = q
        }
      } else {
        chart.data = data
      }

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = "label"
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.minGridDistance = 20

      chart.yAxes.push(new am4charts.ValueAxis())

      // Create series
      function createSeries(field: any, name: any, color: any) {
        let series: any = chart.series.push(new am4charts.LineSeries())
        series.dataFields.valueY = field
        series.dataFields.categoryX = "label"
        series.name = name
        series.tooltipText = "{valueY}"
        series.strokeWidth = 5
        if(color) {
          series.stroke = am4core.color(color)
        }

        let bullet: any = series.bullets.push(new am4charts.CircleBullet())
        bullet.circle.stroke = am4core.color("#fff")
        bullet.circle.strokeWidth = 1
        if(color) {
          bullet.fill = am4core.color(color)
        }

        return series
      }

      createSeries("B2B", "B2B", "#0b7dda")
      createSeries("B2C", "B2C", "#03b237")
      createSeries("total", "Total", "#FF0000")

      chart.legend = new am4charts.Legend()
      chart.cursor = new am4charts.XYCursor()
      chart.zoomOutButton.disabled = true
    }
  },

  mounted () {
    this.chartData = _.groupBy(this.chartB2BB2CData, 'year')

    const years = Object.keys(this.chartData).map(Number)
    this.minYear = Math.min(...years)

    this.createChart()
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }
})
